<template>
<div id="dashboard-analytics">
    <vx-card class="">
        <ComunicadosPendientesVue />
    </vx-card>
    <vx-card class="mt-2">
        <VerPerfil />
    </vx-card>
</div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
Vue.use(axios)
import ComunicadosPendientesVue from './components/ComunicadosPendientes.vue'
import VerPerfil from '../usuarios/viewPerfil.vue';
export default {
    data() {
        return {
            popupActive: false,
            institucion: [],
            ciudades: [],
            ciudad: '',
            usuario: [],
            curso: [],
            cursod: [],
            tareasd: [],
            contenidos: [],
            tareasp: [],
            tarease: [],
            provincias: [],
        }
    },
    components: {
        ComunicadosPendientesVue,
        VerPerfil
    },
    created() {
        this.usuario = JSON.parse(localStorage.getItem('usuario'))[0];
    },
    mounted() {
        this.getInstitucion();
        // this.getProvincias();
        // this.buscarParroqui();
    },
    methods: {
        getInstitucion() {
            let me = this;
            me.$vs.loading();
            me.$http.get(this.$server_url + 'institucion/' + this.usuario.institucion_idInstitucion)
                // axios.get("http://localhost:8000/api/institucion/" + this.usuario[0].institucion_idinstitucion)
                .then(function (response) {
                    me.institucion = response.data
                    me.$vs.loading.close();
                })
                .catch(function () {
                    me.$vs.loading.close();
                })
        },
        getProvincias() {
            let me = this;
            me.$vs.loading();
            me.$http.get(this.$server_url + 'provincias')
                // axios.get("http://localhost:8000/api/provincias")
                .then(function (response) {
                    me.provincias = response.data
                    me.$vs.loading.close();
                })
                .catch(function () {
                    me.$vs.loading.close();

                })
        }

    },
}
</script>

<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
    .greet-user {
        position: relative;

        .decore-left {
            position: absolute;
            left: 0;
            top: 0;
        }

        .decore-right {
            position: absolute;
            right: 0;
            top: 0;
        }
    }

    @media(max-width: 576px) {

        .decore-left,
        .decore-right {
            width: 140px;
        }
    }
}

/*! rtl:end:ignore */
</style>
